// Botão de ação ocupado: o padrão obrigatório do v2 para todo botão que chama o servidor (como o campos.js na validação).
// Enquanto a chamada vai e volta, o botão ganha a roda (<span class="roda">, do candidato-v2) antes do rótulo, aria-busy e
// aria-disabled, e o 2º toque não envia de novo. aria-disabled, e não disabled: o foco não sai do botão. O rótulo continua.

export const ocupado = botao => botao?.getAttribute('aria-busy') === 'true';

export function ocupar(botao, ligar = true) {
    if (!botao) {
        return;
    }
    if (ligar) {
        botao.setAttribute('aria-busy', 'true');
        botao.setAttribute('aria-disabled', 'true');
        botao.dataset.ocupado = '';
        if (!botao.querySelector(':scope > .roda')) {
            botao.insertAdjacentHTML('afterbegin', '<span class="roda" aria-hidden="true"></span>');
        }
        return;
    }
    botao.removeAttribute('aria-busy');
    botao.removeAttribute('aria-disabled');
    delete botao.dataset.ocupado;
    botao.querySelector(':scope > .roda')?.remove();
}

// Roda a tarefa com o botão ocupado e devolve o que ela devolver (undefined se o botão já estava ocupado).
// manter(resultado): true quando a tarefa sai da página (navega ou recarrega) — o botão fica ocupado até a página trocar;
// com erro (exceção) ele sempre volta.
export async function comBotao(botao, tarefa, { manter } = {}) {
    if (ocupado(botao)) {
        return undefined;
    }
    ocupar(botao);
    let resultado;
    let sai = false;
    try {
        resultado = await tarefa();
        sai = !!manter?.(resultado);
        return resultado;
    } finally {
        if (!sai) {
            ocupar(botao, false);
        }
    }
}

// Voltar para a página pelo cache do navegador (bfcache) traz o botão como estava, ocupado: ele volta ao normal.
window.addEventListener('pageshow', e => {
    if (e.persisted) {
        document.querySelectorAll('[data-ocupado]').forEach(b => ocupar(b, false));
    }
});
